// «Consumi»: oggi e gli ultimi 7 giorni, in token e in euro quando il provider dà un costo.
import { eur, tokens as fmtTokens } from '../../../lib/format';
import type { Usage } from '../../../lib/api';
import { Widget } from '../Widget';
import { Bars } from './Bars';

const DAY = new Intl.DateTimeFormat('it-IT', { weekday: 'narrow' });

export function UsageCard({ usage }: { usage: Usage | null }) {
  if (!usage)
    return (
      <Widget title="Consumi" icon="coins" tint="sun">
        <div className="t-caption faint">Leggo i consumi…</div>
      </Widget>
    );
  const days = usage.days.slice(-7);
  const tok = usage.tokens.slice(-7);
  const cost = usage.costEur.slice(-7);
  const today = tok[tok.length - 1] ?? 0;
  const week = tok.reduce((a, b) => a + b, 0);
  const weekEur = cost.reduce((a, b) => a + b, 0);
  return (
    <Widget title="Consumi" icon="coins" tint="sun">
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
        <span className="t-display">{fmtTokens(today)}</span>
        <span className="t-caption dim">
          token oggi{cost[cost.length - 1] ? ` · ${eur(cost[cost.length - 1])}` : ''}
        </span>
        <span className="t-caption faint" style={{ marginLeft: 'auto' }}>
          {fmtTokens(week)} in 7 giorni{weekEur ? ` · ${eur(weekEur)}` : ''}
        </span>
      </div>
      <div style={{ flex: 1, minHeight: 110, display: 'grid', alignContent: 'end', gap: 6 }}>
        <Bars
          values={tok}
          days={days}
          height={130}
          rainbow
          format={(v) => `${fmtTokens(v)} token`}
        />
        <div style={{ display: 'flex', gap: 3 }}>
          {days.map((d) => (
            <span key={d} className="t-caption faint" style={{ flex: 1, textAlign: 'center' }}>
              {DAY.format(new Date(`${d}T12:00:00`)).toUpperCase()}
            </span>
          ))}
        </div>
      </div>
    </Widget>
  );
}
